import { IsString, MaxLength } from "class-validator";

export class AddressSearchDTO {

    @IsString()
    @MaxLength(50)
    name: string;

}
